document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js-tsc-locator").forEach(initLocator);
});

function escHtml(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function initLocator(root) {
  const searchInput = root.querySelector(".tsc-search-input");
  const regionSelect = root.querySelector(".tsc-filter-region");
  const typeSelect = root.querySelector(".tsc-filter-type");
  const noResultsEl = root.querySelector(".tsc-no-results");
  const mapFrame = root.querySelector(".tsc-map-frame");
  // All individual location buttons rendered by Liquid
  const rawItems = Array.from(root.querySelectorAll(".tsc-item"));

  // ── Grouping ──────────────────────────────────────────────────────────────
  // Collect items by group name
  const buckets = {}; // groupName → [item, ...]
  rawItems.forEach((item) => {
    const g = (item.dataset.group || "").trim();
    if (g) (buckets[g] = buckets[g] || []).push(item);
  });

  // For groups with 2+ items, build a collapsible wrapper card
  const groupData = {}; // groupName → { wrapper, header, sub, items }

  Object.entries(buckets).forEach(([name, items]) => {
    if (items.length < 2) return; // single-item groups stay standalone

    const wrapper = document.createElement("div");
    wrapper.className = "tsc-group";

    const header = document.createElement("button");
    header.type = "button";
    header.className = "tsc-group-header";
    header.setAttribute("aria-expanded", "false");
    header.innerHTML =
      `<span class="tsc-item-name">${escHtml(name)}</span>` +
      `<span class="tsc-group-count">${items.length}\u00a0locations</span>` +
      `<span class="tsc-group-chevron" aria-hidden="true"></span>`;

    const sub = document.createElement("div");
    sub.className = "tsc-group-items";
    sub.hidden = true;

    wrapper.appendChild(header);
    wrapper.appendChild(sub);

    // Insert wrapper where the first item sits, then move all items inside
    items[0].parentNode.insertBefore(wrapper, items[0]);
    items.forEach((item) => sub.appendChild(item));

    header.addEventListener("click", () => {
      const opening = sub.hidden;
      sub.hidden = !opening;
      header.setAttribute("aria-expanded", String(opening));
      wrapper.classList.toggle("is-open", opening);
      if (opening) {
        // Auto-select + map the first visible sub-item when opening
        const first = items.find((i) => i.style.display !== "none");
        if (first) selectItem(first);
      }
    });

    groupData[name] = { wrapper, header, sub, items };
  });

  // ── Selection ─────────────────────────────────────────────────────────────
  function selectItem(item) {
    rawItems.forEach((i) => i.classList.remove("is-selected"));
    item.classList.add("is-selected");
    const url = item.dataset.map;
    if (mapFrame && url && mapFrame.src !== url) mapFrame.src = url;
  }

  rawItems.forEach((item) => {
    item.addEventListener("click", () => selectItem(item));
  });

  // ── Filtering ─────────────────────────────────────────────────────────────
  function applyFilters() {
    const q = (searchInput?.value || "").trim().toLowerCase();
    const regionVal = (regionSelect?.value || "all").toLowerCase();
    const typeVal = (typeSelect?.value || "all").toLowerCase();

    let anyVisible = false;
    let firstVisible = null;
    let firstVisibleGroup = null;

    rawItems.forEach((item) => {
      const name = (item.dataset.name || "").toLowerCase();
      const addr = (item.dataset.address || "").toLowerCase();
      const region = (item.dataset.region || "").toLowerCase();
      const tags = (item.dataset.tags || "").toLowerCase();
      const group = (item.dataset.group || "").trim();
      const inGroup = group && groupData[group];

      const matchSearch = !q || name.includes(q) || addr.includes(q);
      const matchRegion = regionVal === "all" || region === regionVal;
      const matchType = typeVal === "all" || tags.includes(typeVal);
      const visible = matchSearch && matchRegion && matchType;

      item.style.display = visible ? "" : "none";

      if (visible) {
        anyVisible = true;
        if (!firstVisible) {
          firstVisible = item;
          firstVisibleGroup = inGroup ? group : null;
        }
      }
    });

    // Show/hide group wrappers based on sub-item visibility
    Object.values(groupData).forEach(({ wrapper, items }) => {
      const anySubVisible = items.some((i) => i.style.display !== "none");
      wrapper.style.display = anySubVisible ? "" : "none";
    });

    if (noResultsEl) noResultsEl.hidden = anyVisible;

    // Auto-select first visible item, opening its group if needed
    rawItems.forEach((i) => i.classList.remove("is-selected"));

    if (firstVisible) {
      firstVisible.classList.add("is-selected");

      if (firstVisibleGroup && groupData[firstVisibleGroup]) {
        const { sub, header, wrapper } = groupData[firstVisibleGroup];
        if (sub.hidden) {
          sub.hidden = false;
          header.setAttribute("aria-expanded", "true");
          wrapper.classList.add("is-open");
        }
      }

      const url = firstVisible.dataset.map;
      if (mapFrame && url && mapFrame.src !== url) mapFrame.src = url;
    }
  }

  if (searchInput) searchInput.addEventListener("input", applyFilters);
  if (regionSelect) regionSelect.addEventListener("change", applyFilters);
  if (typeSelect) typeSelect.addEventListener("change", applyFilters);

  applyFilters();
}
